<template>
  <div class="alarm-card" @mouseleave="onMouseLeave" @mouseover="onMouseOver">
    <div class="card-header">
      <span class="card-title">{{ data.alarmContent }}</span>
    </div>
    <div class="card-body">
      <div class="info-item">
        <span class="info-label">时间范围：</span>
        <span class="info-value">{{ data.timeRange }}秒</span>
      </div>
      <div class="info-item">
        <span class="info-label">持续时长：</span>
        <span class="info-value">{{ data.duration }}秒</span>
      </div>
    </div>
    <div class="card-footer">
      <div class="btn-content">
        <img @click="() => editData(data)" alt="编辑" class="action-btn edit-btn" 
             src="@/assets/images/icon/edit.png"
             v-show="showBtn">
        <img @click="() => deleteData(data.id)" alt="删除" class="action-btn delete-btn" 
             src="@/assets/images/icon/delete.png"
             v-show="showBtn">
      </div>
    </div>
  </div>
</template>

<script>

import {deleteUpgrade} from "@/network/alarm-convergence";

export default {
  name: "AlarmUpgradeComp",
  data() {
    return {
      showBtn: false,
      data: this.upgradeData,
    }
  },
  props: {
    upgradeData: {
      type: Object,
      default: () => {
      },
    }
  },
  methods: {
    onMouseOver() {
      this.showBtn = true
    },
    onMouseLeave() {
      this.showBtn = false
    },
    //删除策略
    deleteData(id) {
      this.$confirm('是否确认删除该策略', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            deleteUpgrade(id).then(res => {
              if (res.code === 0) {
                this.$message.success("删除成功!")
              } else {
                this.$message.error("删除失败!")
              }
              this.$emit("init");
            })
          }
        }
      })
    },
    //编辑策略
    editData(data) {
      this.$emit("openDialog", "edit", data)
    },
    //查看详情按钮事件
    openDialog(alarmUpgradeActionList) {
      this.$emit("openDialog", "detail", alarmUpgradeActionList)
    },
  }
}
</script>

<style scoped>
.alarm-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  transition: all 0.3s;
}


.card-header {
  padding: 16px;
}

.card-title {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  line-height: 1.5;
}

.card-body {
  flex: 1;
  padding: 20px 16px;
  overflow-y: auto;
  margin-left: 20px;
}

.info-item {
  margin-bottom: 16px;
  display: flex;
}

.info-label {
  color: #e8e8e8;
  font-size: 14px;
  margin-right: 8px;
  min-width: 80px;
}

.info-value {
  color: #fff;
  font-size: 14px;
  word-break: break-all;
}

.card-footer {
  padding: 12px 16px;
}

.btn-content {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.action-btn {
  cursor: pointer;
  width: 20px;
  height: 20px;
  transition: all 0.2s;
}

.action-btn:hover {
  transform: scale(1.2);
}

.edit-btn:hover {
  filter: drop-shadow(0 0 2px #299BFF);
}

.delete-btn:hover {
  filter: drop-shadow(0 0 2px #F56C6C);
}
</style>
